import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageMeta from '../components/PageMeta';

const CookiePolicy = () => {
  return (
    <div className="bg-black min-h-screen pt-24 md:pt-48">
      <PageMeta 
        title="Cookie Policy | Living Media Website Experience"
        description="See how Living Media uses cookies to enhance your experience. Learn about site functionality and how to manage your tracking preferences."
      />
      <Header />
      <main className="max-w-[1400px] mx-auto px-6 pb-16 md:pb-32">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center gap-4 mb-6 md:mb-8">
            <div className="w-12 h-[2px] bg-[#BEF264]" />
            <span className="text-[#BEF264] font-black uppercase tracking-[0.4em] text-[10px]">
              User Preferences
            </span>
          </div>
          <h1 className="text-4xl md:text-8xl font-black text-white tracking-tighter leading-none mb-10 md:mb-16 uppercase italic">
            COOKIE <br /><span className="not-italic text-[#BEF264]">POLICY.</span>
          </h1>

          <div className="grid lg:grid-cols-12 gap-10 md:gap-12 border-t border-white/10 pt-10 md:pt-16">
            <aside className="lg:col-span-4">
              <div className="sticky top-32 space-y-4">
                <p className="text-white/40 font-black uppercase tracking-widest text-[9px] md:text-[10px]">Last updated</p>
                <p className="text-white font-medium text-sm md:text-base">January 2026</p>
                <div className="h-px bg-white/5 w-full my-6 md:my-8" />
                <p className="text-white/40 font-black uppercase tracking-widest text-[9px] md:text-[10px]">Tracking</p>
                <p className="text-[#BEF264] font-medium italic text-sm md:text-base">Transparency First</p>
              </div>
            </aside>

            <div className="lg:col-span-8 space-y-10 md:space-y-12">
              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">Introduction</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  Our website uses cookies and similar tracking technologies to enhance your experience, remember your preferences, and improve how the site works. This Cookie Policy explains what cookies are, how we use them, and your choices regarding their use.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">What Are Cookies?</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  Cookies are small text files stored on your device when you visit a website. They help the website function properly and improve performance.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">How We Use Cookies</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  We use cookies to enable core site functionality, analyze traffic, and improve user experience.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">First-Party and Third-Party Cookies</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  Some cookies are set by our website, while others are set by third-party services such as analytics tools.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">Your Choices</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  You can manage or disable cookies in your browser settings. Disabling cookies may affect website functionality.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">Changes to This Policy</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  This policy may be updated periodically. Updates will be posted on this page.
                </p>
              </section>

              <section className="space-y-4 md:space-y-6">
                <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight italic">Contact</h2>
                <p className="text-white/70 leading-relaxed text-base md:text-lg font-medium tracking-tight">
                  If you have questions about this Cookie Policy, please contact us through the website.
                </p>
              </section>
            </div>
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePolicy;